// const calculateTaxSuccess = (state, { designId, taxAmount }) => {
//   debugger;
//   return {
//     ...state,
//     designs: {
//       ...state.designs,
//       [designId]: {
//         taxAmount,
//         ...state.designs[designId],
//       },
//     },
//   };
// };
//

import { getOr } from 'lodash/fp';

const calculateTaxSuccess = (state, { designId, tax }) => ({
  ...state || {},
  designs: {
    ...getOr({}, 'designs')(state),
    [designId]: {
      ...getOr({}, `designs.${designId}`)(state),
      tax,
    },
  },
});


export default calculateTaxSuccess;
